import { useCallback, useEffect, useRef, useState } from 'react'
import { debounce } from 'throttle-debounce'

export const useIsPortableDevice = () => {
  const [isIsPortableDevice, setIsPortableDevice] = useState(false)
  const windowResizeCallback = useRef(
    debounce(150, () => {
      setIsPortableDevice(window.innerWidth < 1128 ? true : false)
    })
  )
  const debounceTellSize = useCallback(() => {
    windowResizeCallback.current()
  }, [windowResizeCallback])

  useEffect(() => {
    window.addEventListener('resize', debounceTellSize)
    return () => {
      window.removeEventListener('resize', debounceTellSize)
    }
  }, [debounceTellSize])
  useEffect(debounceTellSize, [debounceTellSize])
  return isIsPortableDevice
}
